export enum SearchSettingsFieldsKeys {
  Type = 'type',
  Tail = 'tail',
  Color = 'color',
  Breed = 'breed',
  Page = 'page',
}
